import "../css/GradientText.css";

export default function GradientText({
    children,
    className = "",
    colors = ["#f9c307", "#f97307", "#ffcc00", "#f9c307"], // Default colors
    animationSpeed = 20, // Default animation speed in seconds
    showBorder = false, // Default overlay visibility
}) {
    const gradientStyle = {
        backgroundImage: `linear-gradient(to right, ${colors.join(", ")})`,
        animationDuration: `${animationSpeed}s`,
    };

    return (
        <div className={`animated-gradient-text ${className}`}>
            {showBorder && <div className="gradient-overlay" style={gradientStyle}></div>}
            <div className="text-content" style={gradientStyle}>{children}</div>
        </div>
    );
}